import axios from 'axios';

const API = axios.create({
  baseURL: 'https://admined.cgiibnn-esursi.cd/api/',
});

// Injecter le token JWT dans chaque requête
API.interceptors.request.use((config) => {
  const tokens = JSON.parse(localStorage.getItem('tokens'));
  if (tokens?.access) {
    config.headers.Authorization = `Bearer ${tokens.access}`;
  }
  return config;
});

// Rafraîchir automatiquement le token si expiré
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const tokens = JSON.parse(localStorage.getItem('tokens'));
      if (tokens?.refresh) {
        try {
          const { data } = await axios.post('https://admined.cgiibnn-esursi.cd/api/auth/refresh/', {
            refresh: tokens.refresh,
          });
          localStorage.setItem('tokens', JSON.stringify(data));
          originalRequest.headers.Authorization = `Bearer ${data.access}`;
          return API(originalRequest);
        } catch {
          localStorage.removeItem('tokens');
          window.location.href = '/login';
        }
      }
    }
    return Promise.reject(error);
  }
);

export default API;
